<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>Reports</h2>
      </b-col>

      <!--Gear Icon-->
      <b-col lg="6">
        <b-btn class="pull-right ml5" variant="info" @click="openSelectColumns()"><i class="fa fa-cog"></i></b-btn>
        <b-btn class="pull-right ml5" variant="info" @click="bbl()"><i class="fa fa-bullseye"></i></b-btn>
        <download-excel
            :data   = "items"
            :fields = "json_fields"
            type    = "csv"
            :name   = "filename">
            <!--v-b-popover.hover.top="'Export to csv'" -->
            <b-btn class="pull-right"  variant="info"><i class="fa fa-file-excel-o"></i></b-btn>
        </download-excel>
      </b-col>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid>
            <!-- Main table element -->
            <b-row>
              <b-col lg="3" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>

                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-show="rol==='super_admin'" class="my-1"  title="Energy Companies" sm="6" md="3">
                <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="ec_filter" >
                  <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
                  <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col class="my-1"  title="Trucking Companies" sm="6" md="3">
                <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="tc_filter">
                  <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)">All Trucking Companies</b-dropdown-item>
                  <b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col class="my-1"  title="Trucks" sm="6" md="3">
                <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="t_filter">
                  <b-dropdown-item @click="tFilter('All Trucks', 0)">All Trucks</b-dropdown-item>
                  <b-dropdown-item v-for="truck_filter in trucks_filter" @click="tFilter(truck_filter.truck_name, truck_filter.id)">{{truck_filter.truck_name}}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col class="my-1"  title="Truck Type" sm="6" md="3">
                <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="tt_filter">
                  <b-dropdown-item @click="ttFilter('All Truck Types', 0)">All Truck Types</b-dropdown-item>
                  <b-dropdown-item v-for="truck_type_filter in truck_types_filter" @click="ttFilter(truck_type_filter.name, truck_type_filter.id)">{{truck_type_filter.name}}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col class="my-1"  sm="6" md="3">
                <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="u_filter" title="Unload Locations">
                  <b-dropdown-item @click="uFilter('All Unloads', 0)">All Unloads</b-dropdown-item>
                  <b-dropdown-item v-for="unload_location_filter in unload_locations_filter" @click="uFilter(unload_location_filter.legal_location, unload_location_filter.id)">{{unload_location_filter.legal_location}}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col class="my-1" sm="6" md="3" lg="4" title="Initial date">
                <b-form-input id="haul_initial_datetime" v-model="filter_by.initial_date" @input="iFilter()" type="date"></b-form-input>
              </b-col>
              <b-col class="my-1" sm="6" md="3" title="End date">
                <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @input="eFilter()" type="date"></b-form-input>
              </b-col>

              <b-col md="1" lg="1" class="mb-4" style="max-width: 90px; padding-top: 3px; padding-bottom: 3px;">
                <b-button style="height: 100%;" @click="clearFilters()">Clear</b-button>
              </b-col>


              <!--End Active / Trash Selector-->


            </b-row>
            <!-- Shows when loading data-->
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-if="!loadingData && v_filter == 'All' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">

            </b-table>

            <!-- User Interface controls -->
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"> </div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- End New Energy Company Modal-->

    <!-- Configure Columns to Display -->
    <b-modal title="Columns to Display" v-model="configTable" ok-variant="primary">

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
              <b-form-checkbox :disabled="shouldBeDisabled('two_ways_est_hrs')" value="two_ways_est_hrs" @change="actionField('two_ways_est_hrs', 'Est Two Way(hrs)', 0)">Est Two Way(hrs)</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('avg_load_size')" value="avg_load_size" @change="actionField('avg_load_size', 'Avg Load Size', 0)">Avg Load Size</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('avg_m3_day')" value="avg_m3_day" @change="actionField('avg_m3_day', 'Avg Day', 1)">Avg Day</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('charge_type')" value="charge_type" @change="actionField('charge_type', 'Charge Type', 2)">Charge Type</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('company_name')" value="company_name" @change="actionField('company_name','Company Name',3)">Company Name</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_type')" value="cost_type" @change="actionField('cost_type', 'Cost Type',4)">Cost Type</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('fluid_hauled_km')" value="fluid_hauled_km" @change="actionField('fluid_hauled_km','Fluid Hauled(km)',6)">Fluid Hauled(km)</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('loads')" value="loads" @change="actionField('loads', 'Loads',7)">Loads</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate', 'Rate', 8)">Rate</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('short_long_target')" value="short_long_target" @change="actionField('short_long_target', 'Short Long Target', 9)">Short Long Target</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('target_end_date')" value="target_end_date" @change="actionField('target_end_date', 'Target End Date',9)">Target End Date</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('target_start_date')" value="target_start_date" @change="actionField('target_start_date','Target Start Date', 10)">Target Start Date</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('truck_type')" value="truck_type" @change="actionField('truck_type', 'Truck Type', 9)">Truck Type</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
              <b-form-checkbox :disabled="shouldBeDisabled('speed')" value="speed" @change="actionField('speed', 'Speed', 10)">Speed</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('target_volume')" value="target_volume" @change="actionField('target_volume', 'Target Volume', 11)">Target Volume</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('est_bbl_haul_cost')" value="est_bbl_haul_cost" @change="actionField('est_bbl_haul_cost', 'Est Haul Cost', 10)">Est Haul Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('term_fee_m')" value="term_fee_m" @change="actionField('term_fee_m','Term Fee', 12)">Term Fee</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_cost')" value="total_cost" @change="actionField('total_cost','Total Cost',13)">Total Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_regular')" value="total_regular" @change="actionField('total_regular','Total Regular', 14)">Total Regular</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_stb')" value="total_stb" @change="actionField('total_stb','Total STB', 16)">Total STB</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('unload_longitude')" value="unload_longitude" @change="actionField('unload_longitude','Unload Longitude', 14)">Unload Longitude</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('volume_actual')" value="volume_actual" @change="actionField('volume_actual','Volume Actual', 16)">Volume Actual</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('unload_latitude')" value="unload_latitude" @change="actionField('unload_latitude', 'Unload Latitude', 9)">Unload Latitude</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('unload_locations')" value="unload_locations" @change="actionField('unload_locations', 'Unload Locations', 9)">Unload Locations</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('unload_locations')" value="total_stb_time" @change="actionField('total_stb_time', 'Total STB Time', 9)">Total STB Time</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_driving_time')" value="total_driving_time" @change="actionField('total_driving_time', 'Total Driving Time', 9)">Total Driving Time</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-container>
      <!-- </b-form-checkbox-group> -->

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="configTable=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="saveSelectedColumns()">
          Save
        </b-btn>
      </div>

    </b-modal>
    <!-- Configure Columns to Display-->

  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import reports_service from './reports_service'
  import users_service from '../users/users_service'
  import moment from 'moment';

  Vue.use(VueSweetalert2)

  const items = []
  export default {
    name: 'reports',
    created: function() {
      this.getFilters()
      localStorage.removeItem("haulsaPage");
      localStorage.removeItem("targetPage");
      localStorage.removeItem("ftPage");
      localStorage.removeItem("tpPage");
      localStorage.removeItem("oasaPage");
      localStorage.removeItem("oaPage");
      localStorage.removeItem("truckPage");
      localStorage.removeItem("locationPage");
      localStorage.removeItem("tasaPage");
      localStorage.removeItem("rolesPage");
      localStorage.removeItem("servicePage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tcPage");
      localStorage.removeItem("userPage");
      if (!localStorage.reportPage) {
          localStorage.reportPage = 0;
      }
      //this.getAll()
    },
    data() {
      return {
        filename : 'report_'+moment().format('YYYYMMDDHHMM')+'.csv',
        json_fields: {
           "avg_load_size":  "avg_load_size",
           "avg_m3_day":  "avg_m3_day",
           "charge_type":  "charge_type",
           "charge_type_id":  "charge_type_id",
           "company_name":  "company_name",
           "cost_type":  "cost_type",
           "cost_type_id":  "cost_type_id",
           "energy_company_id":  "energy_company_id",
           "est_bbl_haul_cost":  "est_bbl_haul_cost",
           "fluid_hauled_km":  "fluid_hauled_km",
           "loads":  "loads",
           "rate":  "rate",
           "report_id":  "report_id",
           "short_long_target":  "short_long_target",
           "speed":  "speed",
           "target_end_date":  "target_end_date",
           "target_start_date":  "target_start_date",
           "target_volume":  "target_volume",
           "term_fee_m":  "term_fee_m",
           "total_cost":  "total_cost",
           "total_driving_time":  "total_driving_time",
           "total_regular":  "total_regular",
           "total_stb":  "total_stb",
           "total_stb_time":  "total_stb_time",
           "truck_type":  "truck_type",
           "truck_type_id":  "truck_type_id",
           "two_ways_est_hrs":  "two_ways_est_hrs",
           "unload_latitude":  "unload_latitude",
           "unload_location_id":  "unload_location_id",
           "unload_locations":  "unload_locations",
           "unload_longitude":  "unload_longitude",
           "volume_actual":  "volume_actual",
       },
       json_data: [],
       json_meta: [
           [
               {
                   'key': 'charset',
                   'value': 'utf-8'
               }
           ]
       ],
        insert_data: null,
        energy_companies_filter : '',
        trucking_companies_filter :'',
        unload_locations_filter : '',
        truck_types_filter : '',
        drivers_filter: '',
        trucks_filter:'',
        row: 0,
        loadingData: true,
        trash: false,
        dpdt: "Active",
        ec_filter: "All Energy Companies",
        tt_filter: "All Truck Types",
        tc_filter: "All Trucking Companies",
        t_filter: "All Trucks",
        v_filter: "All",
        u_filter: "All Unloads",
        filter_by: {
          "energy_company_id":"",
          "unload_location_id":"",
          "truck_type_id":"",
          "truck_id":"",
          "initial_date":"",
          "end_date":""
        },
        companyName: '',
        companyId: null,
        newEC: false,
        configTable: false,
        items: items,
        v_items:null,
        fieldsSelected: 8,
        maxFieldsSelected: 10,
        tempFields: [],
        fields: [
          {
          key: 'target_start_date',
          label: 'Date',
          sortable: true,
          formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
        }, {
          key: 'unload_locations',
          label: 'Unload',
          sortable: true
        }, {
          key: 'truck_type',
          label: 'Truck Type',
          sortable: true
        }, {
          key: 'volume_actual',
          label: 'Deliveries',
          sortable: true,
          formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
        }, {
          key: 'target_volume',
          label: 'Target',
          sortable: true,
          formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
        }, {
          key: 'loads',
          label: '# Loads',
          sortable: true
        }, {
          key: 'total_cost',
          label: 'Total Cost',
          sortable: true,
          formatter: (value) => { return '$'+Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
        }],
        currentPage: parseInt(localStorage.reportPage),
        perPage: 25,
        totalRows: items.length,
        pageOptions: [25, 50, 100],
        sortBy: null,
        sortDesc: false,
        filter: null,
        modalInfo: {
          title: '',
          content: ''
        },
        modalEdit: {
          title: ''
        },
        selectedItems: [
          'target_start_date',
          'unload_locations',
          'truck_type',
          'volume_actual',
          'target_volume',
          'loads',
          'total_cost',
        ],
        rol:'',
        view:true,
        unit:'',
        filters_save: {
          energy_company_id     : 0,
          energy_company_name   : 'All Energy Companies',
          truck_id              : 0,
          truck_name            : 'All Trucks',
          trucking_company_id         : 0,
          trucking_company_name            : 'All Trucking Comanies',
          truck_type_id         : 0,
          truck_type_name       : 'All Truck Types',
          unload_id             : 0,
          unload_name           : 'All Unloads',
          initial_date          : '',
          end_date              : '',
          sortby                : null,
          sortdesc              : false
        },
        filters_start: {
          energy_company_id     : 0,
          trucking_company_id     : 0,
          truck_id              : 0,
          load_id               : 0,
          unload_id             : 0,
          initial_date          : '',
          end_date              : '',
          sortby                : '',
          sortdesc              : false
        }
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      rowClicked(row) {
        localStorage.reportPage = this.currentPage;
      },
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      openSelectColumns() {
        this.tempFields = [...this.fields]
        this.configTable = true
      },
      saveSelectedColumns() {
        this.fields = [...this.tempFields]
        reports_service.saveSelectedColumns(this.fields)
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  setTimeout(
                    () => {
                      this.configTable = false
                    }, 500)
                }
              })
          })
      },
      bbl() {
        users_service.bbl()
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.loadingData = true
                      this.getAll()
                }
              })
          })
      },
      shouldBeDisabled(option) {
        return (this.fieldsSelected >= this.maxFieldsSelected) && this.tempFields.map(o => o.key).indexOf(option) == -1
      },
      actionField(option, label, position) {
        var fieldsLength = this.tempFields.length
        var fieldIsActive = false
        for (var i = 0; i <= fieldsLength; i++) {
          fieldIsActive = true
          try {
            if (this.tempFields[i].key === option || this.tempFields[i] === option) {
              this.tempFields.splice(i, 1)
              fieldIsActive = false
              break
            }
          } catch (err) {

            if (option=='target_start_date' || option=='target_end_date') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
              }
            } else if (option=='total_cost' || option=='total_stb' || option=='total_regular' || option=='term_fee_m' || option=='rate') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return '$'+Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
              }
            } else if (option=='volume_actual' || option=='avg_load_size' || option=='target_volume' || option=='short_long_target'|| option=='avg_m3_day' ) {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
              }
            } else if (option=='fluid_hauled_km') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' km' }
              }
            } else if (option=='speed') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' km/h' }
              }
            }
            else {
            option = {
              key: option,
              label: label,
              sortable: true
            }
            }
            this.tempFields.splice(position, 0, option)
          }
        }
        this.fieldsSelected = this.tempFields.length
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.currentPage = parseInt(localStorage.reportPage)
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      clearFilters() {
        this.ec_filter = "All Energy Companies";
        this.tt_filter = "All Truck Types";
        this.tc_filter = "All Trucking Companies";
        this.t_filter = "All Trucks";
        this.v_filter = "All";
        this.u_filter = "All Unloads";
        this.sortBy   = null
        this.sortDesc = false
        this.filter_by = {
          "energy_company_id":"",
          "unload_location_id":"",
          "truck_type_id":"",
          "truck_id":"",
          "trucking_company_id":"",
          "initial_date":"",
          "end_date":""
        },
        this.filters_save = {
          energy_company_id     : 0,
          energy_company_name   : 'All Energy Companies',
          trucking_company_id     : 0,
          truncin_company_name   : 'All Trucking Companies',
          truck_id              : 0,
          truck_name            : 'All Trucks',
          truck_type_id         : 0,
          truck_type_name       : 'All Truck Types',
          unload_id             : 0,
          unload_name           : 'All Unloads',
          initial_date          : '',
          end_date              : '',
          sortby                : null,
          sortdesc              : false
        }

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },

      ecFilter(ec_filter,id) {
        this.ec_filter = ec_filter
        this.filter_by['energy_company_id'] = id == 0 ? '' : id

        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_company_id = id

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      tcFilter(tc_filter,id) {
        this.tc_filter = tc_filter
        this.filter_by['trucking_company_id'] = id == 0 ? '' : id

        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      tFilter(t_filter,id) {
        this.t_filter = t_filter
        this.filter_by['truck_id'] = id == 0 ? '' : id

        this.filters_save.truck_name =  t_filter
        this.filters_save.truck_id = id

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      ttFilter(tt_filter,id) {
        this.tt_filter = tt_filter
        this.filter_by['truck_type_id'] = id == 0 ? '' : id

        this.filters_save.truck_type_name =  tt_filter
        this.filters_save.truck_type_id = id
        this.saveFilters()

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.u_filter = u_filter
        this.filter_by['unload_location_id'] = id == 0 ? '' : id

        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_id = id

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      iFilter() {
        if (this.filter_by['initial_date']=='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          this.filters_save.initial_date = ''
        }

        this.filters_save.initial_date = this.filter_by.initial_date

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      eFilter() {
        if (this.filter_by['end_date'] =='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }

        this.filters_save.end_date = this.filter_by.end_date

        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      getAll() {
        this.items = []
        this.v_items = []
        reports_service.getAll(this.filter_by)
          .then(data => {
            if (data.status == 'success') {

             this.energy_companies_filter = data.energy_companies_filter
             this.unload_locations_filter = data.unloads_locations_filter
             this.trucking_companies_filter = data.trucking_companies_filter
             this.trucks_filter = data.trucks_filter
             this.truck_types_filter = data.truck_types_filter
             this.rol = data.rol
             if (this.rol =='super_admin') {this.view=true}
             else {this.view=false}
             this.items = data.haul_report

              for (let i = 0; i < this.items.length; i++) {
                let total_cost=this.items[i].total_cost
                let total_stb=this.items[i].total_stb
                let total_regular=this.items[i].total_regular
                let term_fee_m=this.items[i].term_fee_m
                let rate=this.items[i].rate
                let est_bbl_haul_cost=this.items[i].est_bbl_haul_cost

                let volume_actual=this.items[i].volume_actual
                if (this.items[i].volume_actual.indexOf('bbl')!= -1) {
                  this.unit=' bbl'
                } else {
                  this.unit=' m³'
                }
                let avg_load_size=this.items[i].avg_load_size
                let target_volume=this.items[i].target_volume
                let short_long_target=this.items[i].short_long_target
                let avg_m3_day=this.items[i].avg_m3_day

                let fluid_hauled_km=this.items[i].fluid_hauled_km
                let speed=this.items[i].speed

                this.items[i].total_cost=parseFloat(total_cost.replace("$", ""))
                this.items[i].total_stb=parseFloat(total_stb.replace("$", ""))
                this.items[i].total_regular=parseFloat(total_regular.replace("$", ""))
                this.items[i].term_fee_m=parseFloat(term_fee_m.replace("$", ""))
                this.items[i].rate=parseFloat(rate.replace("$", ""))

                this.items[i].volume_actual=parseFloat(volume_actual.replace(this.unit, ""))
                this.items[i].avg_load_size=parseFloat(avg_load_size.replace(this.unit, ""))
                this.items[i].target_volume=parseFloat(target_volume.replace(this.unit, ""))
                this.items[i].short_long_target=parseFloat(short_long_target.replace(this.unit, ""))
                this.items[i].avg_m3_day=parseFloat(avg_m3_day.replace(this.unit, ""))

                this.items[i].fluid_hauled_km=parseFloat(fluid_hauled_km.replace(' km', ""))
                this.items[i].speed=parseFloat(speed.replace(' km/h', ""))
              }
              if (data.select_columns != '') {
               this.fields = []
               this.fields = data.select_columns
              }
              if (this.fields.length>0) {
                this.selectedItems = []
                for (let i = 0; i < this.fields.length; i++) {
                 let key = this.fields[i].key
                 this.selectedItems.push(key)
                  if (key=='target_start_date' || key=='target_end_date') {
                    this.fields[i].formatter=(value) => { return moment(value).format("MMM DD, YYYY") }
                  }
                  if (key=='total_cost' || key=='total_stb' || key=='total_regular' || key=='term_fee_m' || key=='rate'){
                      this.fields[i].formatter= (value) => { return '$'+Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
                  }
                  if (key=='volume_actual' || key=='avg_load_size' || key=='target_volume' || key=='short_long_target'|| key=='avg_m3_day' ) {
                        this.fields[i].formatter= (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
                  }
                  if (key=='fluid_hauled_km' ) {
                        this.fields[i].formatter= (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' km' }
                  }
                  if (key=='speed' ) {
                        this.fields[i].formatter= (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' km/h' }
                  }
                }
              }
             this.loadingData = false
           }else {
             this.$swal(data.status, data.message, data.status)
             this.loadingData = false
             return
           }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      saveFilters() {
        console.log(this.filters_save)
        reports_service.saveFilters(this.filters_save)
          .then((data) => {
                if (data[0] == 'success') {
                    return
                } else {
                    Vue.swal(data[0], data[1], data[0])
                    return
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            return
          })
    },
    getFilters() {
        reports_service.getFilters()
          .then((data) => {
                if (data[0] == 'success') {
                    this.filters_start= data[1]
                    if (this.filters_start.length != 0) {
                      if (this.filters_start[0].energy_company_id != 0) {
                          this.filter_by.energy_company_id = this.filters_start[0].energy_company_id
                      } else {
                          this.filter_by.energy_company_id = ''
                      }
                      if (this.filters_start[0].trucking_company_id != 0) {
                          this.filter_by.trucking_company_id = this.filters_start[0].trucking_company_id
                      } else {
                          this.filter_by.trucking_company_id = ''
                      }
                      if (this.filters_start[0].truck_id != 0) {
                          this.filter_by.truck_id = this.filters_start[0].truck_id
                      } else {
                          this.filter_by.truck_id = ''
                      }
                      if (this.filters_start[0].driver_id != 0) {
                        this.filter_by.users_id = this.filters_start[0].driver_id
                      } else {
                        this.filter_by.users_id = ''
                      }
                      if (this.filters_start[0].load_id != 0) {
                        this.filter_by.load_location_id = this.filters_start[0].load_id
                      } else {
                        this.filter_by.load_location_id = ''
                      }
                      if (this.filters_start[0].unload_id != 0) {
                        this.filter_by.unload_location_id = this.filters_start[0].unload_id
                      } else {
                        this.filter_by.unload_location_id = ''
                      }
                      if (this.filters_start[0].initial_date != null) {
                        this.filter_by.initial_date = this.filters_start[0].initial_date
                      } else {
                        this.filter_by.initial_date = ''
                      }
                      if (this.filters_start[0].end_date != null) {
                      this.filter_by.end_date = this.filters_start[0].end_date
                      } else {
                        this.filter_by.end_date = ''
                      }
                      if (this.filters_start[0].sortby != null) {
                        this.filters_save.sortby = this.filters_start[0].sortby
                        this.sortBy = this.filters_start[0].sortby
                      } else {
                        this.filters_save.sortby = null
                        this.sortBy = null
                      }
                      if (this.filters_start[0].sortdesc != null) {
                        this.filters_save.sortdesc = this.filters_start[0].sortdesc
                        this.sortDesc = this.filters_start[0].sortdesc
                      } else {
                        this.filters_save.sortdesc = false
                        this.sortDesc = false
                      }

                      this.filters_save.energy_company_name  = this.filters_start[0].energycompany_name
                      this.filters_save.energy_company_id    = this.filters_start[0].energy_company_id

                      this.filters_save.trucking_company_name  = this.filters_start[0].trucking_company_name
                      this.filters_save.trucking_company_id    = this.filters_start[0].trucking_company_id

                      this.filters_save.truck_id      = this.filters_start[0].truck_id
                      this.filters_save.truck_name    =  this.filters_start[0].truck_name

                      this.filters_save.truck_type_id       = this.filters_start[0].truck_type_id
                      this.filters_save.truck_type_name     =  this.filters_start[0].truck_type_name

                      this.filters_save.unload_id     = this.filters_start[0].unload_id
                      this.filters_save.unload_name   = this.filters_start[0].unload_name

                      this.filters_save.initial_date  = this.filters_start[0].initial_date
                      this.filters_save.end_date      = this.filters_start[0].end_date
                  //this.filters_save.sortby        = data.filters[0].sortby
                  //this.filters_save.sortdesc      = data.filters[0].sortdesc
                      if (this.filters_save.energy_company_name != null) {
                        this.ec_filter                  = this.filters_save.energy_company_name
                      } else {
                        this.ec_filter                   = "All Energy Companies"
                      }
                      if (this.filters_save.trucking_company_name != null) {
                        this.tc_filter                  = this.filters_save.trucking_company_name
                      } else {
                        this.tc_filter                   = "All Trucking Companies"
                      }
                      if (this.filters_save.truck_name != null) {
                        this.t_filter                   = this.filters_save.truck_name
                      } else {
                        this.t_filter                   = "All Trucks"
                      }
                      if (this.filters_save.truck_type_name != null) {
                        this.tt_filter                   = this.filters_save.truck_type_name
                      } else {
                        this.tt_filter                   = "All Truck Types"
                      }
                      if (this.filters_save.unload_name != null) {
                        this.u_filter                   = this.filters_save.unload_name
                      } else {
                        this.u_filter                   = "All Unloads"
                      }
                      if (this.filters_save.initial_date != null) {
                        this.filter_by.initial_date = this.filters_save.initial_date
                      } else {
                        this.filters_save.initial_date =''
                        this.filter_by.initial_date = ''
                      }
                      if (this.filters_save.end_date != null) {
                        this.filter_by.end_date = this.filters_save.end_date
                      } else {
                        this.filter_by.end_date = ''
                        this.filters_save.end_date =''
                      }
                    } else {
                        this.ec_filter                  = "All Energy Companies"
                        this.tc_filter                  = "All Trucking Companies"
                        this.t_filter                   = "All Trucks"
                        this.tt_filter                  = "All Truck Types"
                        this.u_filter                   = "All Unloads"

                        this.filters_save.energy_company_id    = 0
                        this.filters_save.energy_company_name  = this.ec_filter
                        this.filters_save.trucking_company_id    = 0
                        this.filters_save.truking_company_name  = this.tc_filter
                        this.filters_save.truck_id      = 0
                        this.filters_save.truck_name    =  this.t_filter
                        this.filters_save.truck_type_id       = 0
                        this.filters_save.truck_type_name     =  this.tt_filter
                        this.filters_save.unload_id     = 0
                        this.filters_save.unload_name   = this.u_filter
                        this.filters_save.initial_date  = ''
                        this.filters_save.end_date      = ''
                        this.filters_save.sortby        = null
                        this.filters_save.sortdesc      = false
                        this.filter_by={"initial_date": "", "end_date": "", "truck_id": "", "users_id": "", "unload_location_id": "", "energy_company_id": "", "trucking_company_id": "", "truck_type_id": ""}
                    }
                    this.getAll()
                    this.loadingData = true
                } else {
                    Vue.swal(data[0], data[1], data[0])
                    this.loadingData = false
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
    },
    sortingChanged (ctx) {
      this.filters_save.sortdesc  = ctx.sortDesc
      this.filters_save.sortby    = ctx.sortBy
      this.saveFilters()
    // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
    // ctx.sortDesc ==> true if sorting descending, false otherwise
    }
    }
  }
</script>

<style>
  .table tbody tr:hover {
    background-color: rgb(222, 225, 229);
    color: #030303;
    cursor: pointer;
  }

  table div {
    padding: 0.75rem;
  }

  .table td {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/reports.vue